// extracted by mini-css-extract-plugin
export default {"category-side-items":"CategoryAsideRadio_category-side-items__TM5tt","category-side-span":"CategoryAsideRadio_category-side-span__NhQiI"};